"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VISIBLE_FIELDS_MAP = exports.ENTRY_MAX_COLUMNS_MAP = void 0;
exports.ENTRY_MAX_COLUMNS_MAP = {
    columnsSection: 4,
    sectionIconCards: 4,
    sectionProductCards: 3,
};
exports.VISIBLE_FIELDS_MAP = {
    abTestSection: [{ id: 'featureFlagName' }],
    accordionSection: [
        { id: 'heading' },
        { id: 'body' },
        {
            id: 'items',
            tableFields: [{ id: 'heading' }, { id: 'body' }],
        },
    ],
    antiAtomSection: [{ id: 'component' }],
    atomSection: [{ id: 'html' }, { id: 'css' }],
    bannerSection: [{ id: 'heading' }, { id: 'body' }, { id: 'link', isLink: true }],
    columnsSection: [
        { id: 'heading' },
        { id: 'subheading' },
        { id: 'body' },
        {
            id: 'items',
            tableFields: [{ id: 'header' }, { id: 'body' }, { id: 'button', isLink: true }, { id: 'image', isMedia: true }],
        },
    ],
    componentBlock: [{ id: 'componentName' }],
    emailCaptureFormSection: [{ id: 'heading' }, { id: 'body' }, { id: 'footer' }, { id: 'destinationUrl' }],
    footnoteSection: [{ id: 'body' }],
    heroImageSection: [
        { id: 'heading' },
        { id: 'subheading' },
        { id: 'body' },
        { id: 'image', isMedia: true },
        { id: 'smallImage', isMedia: true },
        { id: 'link', isLink: true },
        { id: 'secondaryLink', isLink: true },
    ],
    heroTextBoxSection: [
        { id: 'heading' },
        { id: 'subheading' },
        { id: 'body' },
        { id: 'link', isLink: true },
        { id: 'image', isMedia: true },
    ],
    heroTextSection: [{ id: 'heading' }, { id: 'body' }],
    iconGrid: [
        { id: 'heading' },
        { id: 'body' },
        {
            id: 'items',
            tableFields: [{ id: 'heading' }, { id: 'body' }, { id: 'image', isMedia: true }],
        },
    ],
    image: [{ id: 'keywords' }, { id: 'textAlternative' }, { id: 'asset', isMedia: true }],
    leadspaceWithShape: [
        { id: 'heading' },
        { id: 'body' },
        { id: 'image', isMedia: true },
        { id: 'link', isLink: true },
        { id: 'secondaryLink', isLink: true },
        { id: 'shape' },
    ],
    listOfLinksBlock: [
        { id: 'heading' },
        { id: 'subheading' },
        {
            // listOfLinksSection
            id: 'items',
            tableFields: [
                { id: 'sectionHeading' },
                {
                    // listOfLinksItem
                    id: 'items',
                    tableFields: [{ id: 'itemHeading' }, { id: 'itemBody' }, { id: 'link', isLink: true }],
                },
            ],
        },
    ],
    media: [{ id: 'key' }, { id: 'media', isMedia: true }],
    panelCardsSection: [
        { id: 'heading' },
        {
            id: 'items',
            tableFields: [{ id: 'panelCode' }, { id: 'corePanelCodes' }, { id: 'link', isLink: true }],
        },
    ],
    postersAndPresentations: [
        { id: 'conference' },
        { id: 'startDate' },
        { id: 'endDate' },
        { id: 'location' },
        { id: 'specialtyArea' },
        { id: 'posters', isLink: true },
        { id: 'presentations', isLink: true },
    ],
    sectionCarousel: [{ id: 'heading' }, { id: 'subheading' }],
    sectionCustomerReview: [
        { id: 'heading' },
        { id: 'body' },
        { id: 'image', isMedia: true },
        { id: 'videoId', isMedia: true },
        { id: 'customerName' },
        { id: 'primaryLink', isLink: true },
    ],
    sectionFactBanner: [
        { id: 'heading' },
        { id: 'subheading' },
        { id: 'body' },
        { id: 'link', isLink: true },
        { id: 'image', isMedia: true },
    ],
    sectionIconCards: [
        { id: 'heading' },
        { id: 'body' },
        { id: 'cardSize' },
        {
            id: 'items',
            tableFields: [{ id: 'heading' }, { id: 'body' }, { id: 'image', isMedia: true }, { id: 'link', isLink: true }],
        },
    ],
    sectionListWithIconBullets: [
        { id: 'heading' },
        {
            id: 'items',
            tableFields: [{ id: 'heading' }, { id: 'body' }, { id: 'icon' }],
        },
    ],
    sectionLogos: [
        { id: 'heading' },
        { id: 'body' },
        { id: 'images', tableFields: [{ id: 'keywords' }, { id: 'textAlternative' }, { id: 'asset', isMedia: true }] },
    ],
    sectionNextActionBanner: [{ id: 'heading' }, { id: 'primaryLink', isLink: true }, { id: 'secondaryLink', isLink: true }],
    sectionProductCards: [
        { id: 'heading' },
        { id: 'body' },
        {
            id: 'items',
            tableFields: [
                { id: 'heading' },
                { id: 'subheading' },
                { id: 'body' },
                { id: 'image', isMedia: true },
                { id: 'primaryLink', isLink: true },
                { id: 'secondaryLink', isLink: true },
            ],
        },
    ],
    sectionStepperHover: [
        { id: 'heading' },
        { id: 'body' },
        { id: 'image', isMedia: true },
        {
            id: 'items',
            tableFields: [{ id: 'heading' }, { id: 'body' }],
        },
    ],
    sectionStepperStatic: [
        { id: 'heading' },
        { id: 'body' },
        { id: 'link', isLink: true },
        {
            id: 'items',
            tableFields: [{ id: 'heading' }, { id: 'body' }, { id: 'image', isMedia: true }],
        },
    ],
    sectionTechSpec: [
        { id: 'heading' },
        { id: 'body' },
        {
            id: 'items',
            tableFields: [{ id: 'subheading' }, { id: 'body' }],
        },
    ],
    tabsSection: [{ id: 'heading' }, { id: 'subheading' }, { id: 'body' }],
    teamsBlock: [
        { id: 'heading' },
        {
            // teamsBlockGroup
            id: 'items',
            tableFields: [
                { id: 'heading' },
                {
                    // teamsBlockMember
                    id: 'items',
                    tableFields: [{ id: 'name' }, { id: 'title' }, { id: 'bio' }, { id: 'image', isMedia: true }],
                },
            ],
        },
    ],
    testCatalogMainCategorySection: [{ id: 'mainCategoryPrCode' }],
    textAndMediaSection: [
        { id: 'heading' },
        { id: 'body' },
        { id: 'primaryLink', isLink: true },
        { id: 'secondaryLink', isLink: true },
    ],
    textCopy: [{ id: 'copy' }],
    webinar: [
        { id: 'title' },
        { id: 'presenters' },
        { id: 'abstract' },
        { id: 'date' },
        { id: 'time' },
        { id: 'link', isLink: true },
        { id: 'specialtyArea' },
    ],
};
//# sourceMappingURL=exportPageToDoc.js.map